import { BeneficiaryFilterDateType } from '@repo/shared/dtos/beneficiary'
import { DateSchemaItem } from '@repo/shared/dtos/structured-data'
import { getLocale, useT } from '@repo/ui/hooks'
import { format } from 'date-fns'

import DateFilterForm from './DateFilterForm'
import { FilterWrapper } from './FilterWrapper'
import { FilterProps } from './types'

export default function DateFilter(props: FilterProps<BeneficiaryFilterDateType, DateSchemaItem>) {
  const { t } = useT({ keyPrefix: 'beneficiary.filters' })
  const formatDate = (dateInMs: number | undefined) => {
    if (dateInMs === undefined || isNaN(dateInMs)) {
      return 'Invalid date'
    }
    return format(new Date(dateInMs), 'dd MMMM yyyy', {
      locale: getLocale(),
    })
  }

  const optionalsCrushed = {
    value: 'value' in props.filter ? formatDate(props.filter.value) : undefined,
    otherValue: 'otherValue' in props.filter ? formatDate(props.filter.otherValue) : undefined,
    operator:
      props.filter.operator === 'in_the_last'
        ? t('operators.in_the_last_days', { count: props.filter.days })
        : props.filter.operator === 'in_the_next'
          ? t('operators.in_the_next_days', { count: props.filter.days })
          : undefined,
  }
  if (props.readonly) return <FilterWrapper {...props} optionalsCrushed={optionalsCrushed} />

  return (
    <FilterWrapper
      {...props}
      optionalsCrushed={optionalsCrushed}
      renderForm={(onCancel) => (
        <DateFilterForm filter={props.filter} onChange={props.onChange} onCancel={onCancel} />
      )}
    />
  )
}
